import styled from "styled-components";
import { RAButtonPrimary, RAButtonSecondary, RARadioButton, RATypography } from "@/components/customs";
import { Row, Col, Modal, Grid } from "antd";
import { IconCloseSvg } from "@/components/svgs";
import { JET_ONE_SUITES_OPTIONS } from "@/config/constants";
import { useState } from "react";
import { HeaderSection } from "../../Cards";
const { useBreakpoint } = Grid;

export function ModalCancelJ1SBooking({
	visible = false,
	isBoth = false,
	departureId,
	arrivalId,
	onClose,
	title = "",
	note = "",
	onConfirm,
}) {
	const screens = useBreakpoint();
	const [typeSelected, setTypeSelected] = useState("");
	const [error, setError] = useState({});

	const onPressConfirm = () => {
		if (isBoth && !typeSelected) {
			setError({ type: "Please select the flight to cancel" });
			return;
		}

		let bookingId;
		if (isBoth && typeSelected === JET_ONE_SUITES_OPTIONS.DEPARTURE) {
			bookingId = departureId;
		} else if (isBoth && typeSelected === JET_ONE_SUITES_OPTIONS.RETURN) {
			bookingId = arrivalId;
		} else {
			bookingId = departureId || arrivalId;
		}
		onConfirm?.(typeSelected, bookingId);
	};

	const _renderContentByType = () => {
		if (isBoth) {
			return (
				<WrapperSelectType>
					<RATypography variant="sub-heading4" color="#222222">
						Do you want to CANCEL this booking?
					</RATypography>
					<RATypography variant="body3" color="#65686F">
						Please select which part of the booking you want to cancel:
					</RATypography>
					<Row gutter={[20, 20]}>
						<Col>
							<RARadioButton
								data-testid="CancelBooking_departureRadio"
								checked={typeSelected === JET_ONE_SUITES_OPTIONS.DEPARTURE}
								title="Departure"
								onChange={() => {
									setTypeSelected(JET_ONE_SUITES_OPTIONS.DEPARTURE);
									setError({});
								}}
							/>
						</Col>
						<Col>
							<RARadioButton
								data-testid="CancelBooking_arrivalRadio"
								checked={typeSelected === JET_ONE_SUITES_OPTIONS.RETURN}
								title="Arrival"
								onChange={() => {
									setTypeSelected(JET_ONE_SUITES_OPTIONS.RETURN);
									setError({});
								}}
							/>
						</Col>
						<Col>
							<RARadioButton
								data-testid="CancelBooking_bothRadio"
								checked={typeSelected === JET_ONE_SUITES_OPTIONS.BOTH}
								title="Both"
								onChange={() => {
									setTypeSelected(JET_ONE_SUITES_OPTIONS.BOTH);
									setError({});
								}}
							/>
						</Col>
					</Row>
					<Row>
						{!!error?.type && (
							<RATypography variant="body3" color="#BF1A2F" top="4px">
								{error.type}
							</RATypography>
						)}
					</Row>
				</WrapperSelectType>
			);
		}

		return (
			<RATypography variant="body3" top="20px" color="#595959">
				{note}
			</RATypography>
		);
	};
	return (
		<Modal
			centered
			closeIcon={<IconCloseSvg />}
			open={visible}
			onCancel={() => onClose()}
			footer={null}
			bodyStyle={{ padding: "30px 30px" }}
			wrapClassName="auth-wrapper"
			width={!screens.xs ? "600px" : "auto"}
			style={{ padding: 0, margin: "20px 0px" }}
			maskClosable={false}
		>
			<ContainerAddContact data-testid="CancelBooking_content">
				<Row>
					<Col md={24}>
						<HeaderSection title={title} />
						{_renderContentByType()}
					</Col>
				</Row>
				<Row justify="center" align="middle" style={{ marginTop: "30px" }} gutter={[12, 20]}>
					<Col>
						<RAButtonSecondary
							data-testid="CancelBooking_cancelBtn"
							title="CANCEL"
							onClick={() => onClose()}
							width={screens.xs ? "136px" : "152px"}
							size={screens.xs ? "small" : "medium"}
						/>
					</Col>
					<Col>
						<RAButtonPrimary
							data-testid="CancelBooking_confirmBtn"
							title="CONFIRM"
							onClick={() => onPressConfirm()}
							width={screens.xs ? "136px" : "152px"}
							size={screens.xs ? "small" : "medium"}
						/>
					</Col>
				</Row>
			</ContainerAddContact>
		</Modal>
	);
}

const ContainerAddContact = styled.div`
	width: "100%";
`;
const WrapperContent = styled.div`
	padding: 0px 20px;
	flex-direction: column;
	align-items: center;
	border-left: 2px solid #ffb11a;
`;
const WrapperSelectType = styled.div`
	display: flex;
	flex-direction: column;
	padding: 16px;
	gap: 12px;
	min-height: 88px;
	background: #fafafa;
	border-radius: 8px;
	margin-top: 20px;
`;
